import Checkbox from '@mui/material/Checkbox';
import React from 'react';

export default function MuiCheckbox({ label, id, sx, ...props }: any) {
    return (
        <div className="flex items-start">
            <Checkbox id={id} {...props} sx={{ ...sx, padding: '8px' }} />
            <label
                htmlFor={id}
                className="body-xxs font-regular cursor-pointer"
                style={{ paddingTop: '10px' }}
            >
                {label}
            </label>
        </div>
    );
}
